export * from '../src/composites/wui-chip/index.js';
//# sourceMappingURL=wui-chip.js.map